package ru.villawonka.app.presentation.screens.conversationDetails.compose

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.core.screen.Screen
import ru.villawonka.app.common.extensions.priceFormat
import ru.villawonka.app.presentation.design.extensions.AppDragView
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.onSurfacePrimary
import ru.villawonka.app.presentation.design.theme.surfaceLow
import ru.villawonka.app.presentation.model.ConversationDetailsUIModel
import ru.villawonka.app.resources.AppResources

class ConversationDetailsScreen(
    private val conversationDetails: ConversationDetailsUIModel
): Screen {

    @Composable
    override fun Content() {
        with (conversationDetails) {
            val originalCurrencyCode = originalCurrency.code
            val displayCurrencyCode = displayCurrency.code

            Column(
                modifier = Modifier.padding(
                    start = 16.dp,
                    end = 16.dp,
                    bottom = 24.dp
                )
            ) {
                AppDragView()
                Text(
                    text = AppResources.strings.conversationDetailsTitle,
                    style = AppTextStyles.titleLargeBold,
                    color = MaterialTheme.colors.onSurfacePrimary
                )
                AppSpacer(16.dp)
                Text(
                    text = AppResources.strings.conversationDetailsDescription(
                        originalCurrencyCode = originalCurrencyCode,
                        displayCurrencyCode = displayCurrencyCode
                    ),
                    style = AppTextStyles.bodyMediumRegular,
                    color = MaterialTheme.colors.onSurfacePrimary
                )
                AppSpacer(16.dp)
                Box(
                    modifier = Modifier
                        .background(
                            color = MaterialTheme.colors.surfaceLow,
                            shape = RoundedCornerShape(24.dp)
                        )
                        .padding(16.dp)
                ) {
                    Text(
                        text = buildAnnotatedString {
                            append("${AppResources.strings.conversationDetailsOriginalCost} " +
                                    "${originalCost.priceFormat()} $originalCurrencyCode\n")
                            append("${AppResources.strings.conversationDetailsExchangeRate} " +
                                    "1 ${originalCurrency.code} = " +
                                    "$exchangeRate $displayCurrencyCode\n")
                            append("${AppResources.strings.conversationDetailsSummary} " +
                                    "${originalCost.priceFormat()} × $exchangeRate = " +
                                    "${displayCost.priceFormat()} $displayCurrencyCode")
                        },
                        style = AppTextStyles.bodyMediumRegular,
                        color = MaterialTheme.colors.onSurfacePrimary,
                    )
                }
            }
        }
    }
}